import { BarChart } from './BarChart';
import { BarChartProps, BarItemData } from './barChart.types';

export function OverviewBarChart<K extends string | number, D extends BarItemData<K>>(
  props: BarChartProps<K, D>
) {
  return (
    <BarChart
      datatip={() => ({ content: '' })}
      zoomAndScroll="off"
      plotArea={{
        yMajorTick: {
          isRendered: false
        },
        xMajorTick: {}
      }}
      xAxis={{
        tickLabel: {
          autoRotate: false,
          // @ts-ignore
          isRendered: props.xAxis?.timeAxisType ? true : false
        }
      }}
      series={props.series}
      groups={props.groups}
      getDataItem={props.getDataItem}
      yAxis={{
        tickLabel: {
          isRendered: false
        }
      }}
      overview="off"
    />
  );
}
